import app from '../app.first';
import $ from 'jquery';

app.ContactUs = class extends app.Component {
    constructor($this) {
        super($this);
        this.$form = $this.find('form');
		$(() => this.onDocumentReady($this));
	}
    
	onDocumentReady($this) {
        var mapProp = {
            center: new google.maps.LatLng(-33.93301, 18.4564413),
            zoom: 10
        };
        var map = new google.maps.Map(document.getElementById("google_map"), mapProp);

        if (this.$form.data('trustedClient')) {
            return true;
        }

        let allowSubmit = false;
        this.$form.on('submit', function() {
            return allowSubmit;
        });

        this.$form.on('formvalid.zf.abide', (e) => {
            grecaptcha.ready(() => {
                grecaptcha.execute('6Ldrh4gUAAAAAFo9_t2rmN59KWOEBQ14S5-lyOin', {action: 'action_name'})
                .then((token) => {
                    $.ajax({
                        url: "/captcha/verify",
                        data: {
                            response: token
                        },
                        // dataType: 'json',
                        method: 'POST',
                        beforeSend: (xhr) => {
                            xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
                        },
                        success: ((response) => {
                            if (response.success && response.score > response.tolerance) {
                                allowSubmit = true;
                                this.$form.trigger('submit');
                            }
                        })
                    });
                });
            });
        });
    }
}